import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

type RemoveWorkersFromSquadProps = {
  squadId: string;
  workerIds: string[];
};

export const useRemoveWorkersFromSquad = () => {
  return useMutation(
    [`removeWorkersFromSquad`],
    ({ squadId, workerIds }: RemoveWorkersFromSquadProps) =>
      apiFetch(null, `internal/expert-management/removeWorkersFromSquad`, {
        method: 'POST',
        body: {
          squadId,
          workerIds,
        },
      }),
  );
};
